import Client from './Client'

export default class Company extends Client {

  async updateLogo(token, base64) {
    try {
      return await this.request(token, 'post', 'profil/logo', { data: base64 }, null)
    } catch (error) {
      throw new Error(error)
    }
  }
}
